import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "react-phone-input-2/lib/bootstrap.css";

const ReusableForm = ({
  fields,
  handleChange,
  handleSubmit,
  passwordVisibility,
  confirmPasswordVisibility,
  errors,
  togglePasswordVisibility,
  toggleConfirmPasswordVisibility,
  formData,
  isApiLoading,
  type,
  handleCloseModal,
  isDisabled,
  enableCancelButton = true,
  termsAndConditions = false,
  TermsAndConditionsComponent,
}) => {
  const isOdd = fields.length % 2 !== 0;

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {fields?.map((field, index) => {
            // Determine if this is the last field and if the total number of fields is odd
            const isLastField = index === fields.length - 1;

            return (
              <Grid
                item
                xs={isLastField && isOdd ? 12 : 12}
                sm={isLastField && isOdd ? 12 : 6}
                key={index}
              >
                <Box sx={{ position: "relative" }}>
                  {field?.type !== "phone" && (
                    <TextField
                      label={field?.label + (field?.required ? " *" : "")}
                      variant="outlined"
                      fullWidth
                      value={formData?.formData?.[field?.name] || ""}
                      disabled={field?.isDisabled}
                      type={
                        field?.type === "password" && field?.name === "Password"
                          ? passwordVisibility
                            ? "text"
                            : "password"
                          : field?.type === "password" &&
                            field?.name === "conPass"
                          ? confirmPasswordVisibility
                            ? "text"
                            : "password"
                          : field.type
                      }
                      name={field?.name}
                      id={field?.id}
                      onChange={(e) =>
                        handleChange(field?.name, e.target?.value)
                      }
                      InputProps={{
                        endAdornment: field?.type === "password" && (
                          <IconButton
                            onClick={
                              field?.name === "Password"
                                ? togglePasswordVisibility
                                : toggleConfirmPasswordVisibility
                            }
                            edge="end"
                          >
                            {field?.name === "Password" ? (
                              passwordVisibility ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )
                            ) : confirmPasswordVisibility ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        ),
                      }}
                      inputProps={{
                        autoComplete:
                          field?.name === "Password" ? "new-password" : "off",
                      }}
                    />
                  )}

                  {field?.type === "phone" && (
                    <PhoneInput
                      country={"us"}
                      enableSearch={true}
                      name={formData?.formData?.phone}
                      onChange={(e) => handleChange(field?.name, e)}
                      value={formData?.formData?.phone || ""}
                      disabled={field?.isDisabled}
                      inputStyle={{
                        height: "56px",
                      }}
                      required={true}
                    />
                  )}

                  {errors?.[field?.errorKey] && (
                    <Typography variant="caption" color="error">
                      {errors[field.errorKey]}
                    </Typography>
                  )}
                </Box>
              </Grid>
            );
          })}
          <Box sx={{ marginLeft: "16px", marginBottom: 0, marginTop: "10px" }}>
            {termsAndConditions && TermsAndConditionsComponent}
          </Box>
        </Grid>

        {type === "register" ? (
          <Box sx={{ textAlign: "center", marginTop: 4 }}>
            <Button
              type="submit"
              variant="contained"
              sx={{ width: "100%", borderRadius: "30px" }}
              disabled={isApiLoading}
            >
              {isApiLoading ? (
                <CircularProgress
                  size={24}
                  sx={{ color: "white", marginRight: 1 }}
                />
              ) : (
                "Register"
              )}
            </Button>
          </Box>
        ) : (
          <Box display="flex" justifyContent="flex-end" mt={2}>
            {enableCancelButton && (
              <Button
                variant="outlined"
                onClick={handleCloseModal}
                sx={{ color: "red" }}
              >
                Cancel
              </Button>
            )}
            <Button
              type="submit"
              variant="contained"
              disabled={isDisabled || isApiLoading}
              sx={{ ml: 2 }}
            >
              {type === "add" ? "Add" : "Update"}
              {isApiLoading && (
                <CircularProgress
                  size={24}
                  sx={{ color: "white", marginRight: 0, marginLeft: 0.5 }}
                />
              )}
            </Button>
          </Box>
        )}
      </form>
    </Box>
  );
};

export default ReusableForm;
